import * as React from "react";
import {
  makeStyles,
  MenuButton,
  MenuPopover,
  MenuTrigger,
  Menu,
  MenuList,
  Body1,
  MenuItemRadio,
  MenuDivider
} from "@fluentui/react-components";

import { ChevronDownRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  contentHeader: {
    marginTop: "0"
  },
  button: {
    backgroundColor: "rgba(245,245,245,0.1)",
    border: "0px",
    width: "100%",
    "& .fui-MenuButton__menuIcon": {
      width: "18px",
      height: "18px"
    }
  },
  textButtonContainer: {
    display: "flex",
    flex: "1",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  textButton: {
    whiteSpace: "nowrap", // Add this lin
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%"
  },
  menuIcon: {
    width: "18px",
    height: "18px",
    fontSize: "18px"
  },
  menuListItem: {
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)"
    },
    "&:hover > * ": {
      color: "inherit!important"
    }
  }
});

export const MicPopoverSelect = ({
  name,
  options,
  value,
  onChange,
  Icon,
  children,
  positioning,
  onClick,
  popoverClassName = {},
  ...props
}) => {
  const styles = useStyles();

  const [selectedValue, setSelectedValue] = React.useState(
    options.find(option => JSON.stringify(option.value) === JSON.stringify(value))?.label
  );

  const [checkedValues, setCheckedValues] = React.useState({ [name]: [value] });
  React.useEffect(() => {
    setCheckedValues({ [name]: [value] });
  }, [value]);

  React.useEffect(() => {
    setSelectedValue(options.find(option => JSON.stringify(option.value) === JSON.stringify(value))?.label);
  }, [value]);

  const onChangeChecked = (e, { name, checkedItems }) => {
    setCheckedValues(s => ({ ...s, [name]: checkedItems }));
  };

  return (
    <Menu {...props} checkedValues={checkedValues} onCheckedValueChange={onChangeChecked} positioning={positioning}>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton
          appearance="filled-lighter"
          className={styles.button}
          icon={<Icon />}
          menuIcon={<ChevronDownRegular className={styles.menuIcon} />}
          onClick={onClick}
        >
          <div className={styles.textButtonContainer}>
            <Body1 className={styles.textButton}>{selectedValue}</Body1>
          </div>
        </MenuButton>
      </MenuTrigger>

      <MenuPopover tabIndex={-1} className={popoverClassName}>
        <MenuList>
          {options.map(option => (
            <MenuItemRadio
              name={name}
              className={styles.menuListItem}
              onClick={() => onChange(option.value)}
              style={{ color: option.value === value ? "inherit" : "var(--Gray-3, #828282)" }}
              value={option.value}
              key={option.label}
            >
              {option.label}
            </MenuItemRadio>
          ))}
          {children && (
            <>
              <MenuDivider />
              {children}
            </>
          )}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
